const ROLE = {
  STUDENT_PLATFORM: 'studentplatform',
  STUDENT_LIVE: 'studentlive',
  ADMIN: 'admin',
  COURSE_CREATOR: 'coursecreator',
  MENTOR: 'mentor',
};

export default ROLE;
